// Mock data for Bring-A-Nurse Senior Companion website

export const blogPosts = [
{
  id: '1',
  title: 'Why a Nurse Companion is Essential for Senior Care',
  slug: 'why-nurse-companion-essential-senior-care',
  excerpt: 'Navigating the medical system can be overwhelming for seniors and their families. Discover how a professional nurse companion can help you advocate for better care, avoid unnecessary costs, and reduce suffering.',
  content: `<h2>The Medical System Can Be Confusing and Overwhelming</h2>
    
    <p>As we age, medical appointments become more frequent, diagnoses more complex, and treatment options more confusing. Many seniors leave doctor's offices with more questions than answers, unsure about their next steps or what their doctor really meant.</p>
    
    <h2>The Critical Role of a Nurse Companion</h2>
    
    <p>A professional nurse companion bridges the gap between medical professionals and patients, serving as an advocate, interpreter, and guide through the healthcare maze. Here's why this matters:</p>
    
    <h3>1. Medical Knowledge at Your Side</h3>
    <p>Nurse companions understand medical terminology, treatment protocols, and healthcare systems. They can ask the right questions, understand complex explanations, and help you make informed decisions about your care.</p>
    
    <h3>2. Advocacy When You Need It Most</h3>
    <p>Sometimes patients need someone to speak up on their behalf. A nurse companion knows when to advocate for additional tests, clarification on prescriptions, or alternative treatment options. They ensure your concerns are heard and addressed.</p>
    
    <h3>3. Reducing Stress and Anxiety</h3>
    <p>Having a knowledgeable, caring professional by your side reduces the anxiety that often accompanies medical appointments. You can focus on your health while your nurse companion manages the details.</p>
    
    <h2>When to Seek a Nurse Companion</h2>
    
    <p>Consider a nurse companion if you or your loved one:</p>
    <ul>
      <li>Has multiple chronic conditions</li>
      <li>Feels confused or overwhelmed before, during, and after medical appointments</li>
      <li>Has difficulty understanding or remembering doctor's instructions</li>
      <li>Needs help understanding their doctor's explanations</li>
      <li>Would benefit from someone to ask important questions</li>
    </ul>
    
    <h2>The Peace of Mind Factor</h2>
    
    <p>Perhaps most importantly, a nurse companion provides peace of mind. Families can rest easier knowing their loved one has professional support during medical appointments. Seniors feel more confident and less alone in managing their health.</p>
    
    <h2>Making the Connection</h2>
    
    <p>At Bring-A-Nurse Senior Companion PLLC, we believe care isn't just about treatment—it's about making meaningful connections. Our experienced nurses provide the guidance, comfort, and support that transforms a stressful medical experience into a manageable, even positive one.</p>
    
    <p>If you or a loved one could benefit from compassionate, professional support during medical appointments, we're here to help. Contact us today to set up your consultation and Bring-A-Nurse to your next doctor's visit.</p>`,
  author: 'Bring-A-Nurse Senior Companion',
  publishedDate: '2025-01-15',
  category: 'Senior Care',
  image: 'https://images.unsplash.com/photo-1758691462858-f1286e5daf40'
}];


export const services = [
{
  id: '1',
  title: "Attend Appointments",
  description: "We attend seniors doctor appointments, ensuring they never face medical visits alone.",
  icon: 'Stethoscope',
  details: "Our nurse will go to your appointments with you, take notes, ask clarifying questions, and ensure you understand all instructions before leaving."
},
{
  id: '2',
  title: 'Medical Advocacy',
  description: 'We help ask the right questions and explain medical information in clear, understandable terms.',
  icon: 'MessageCircle',
  details: 'We translate complex medical jargon, help you understand your options, and ensure your concerns are properly communicated to healthcare providers.'
},
{
  id: '3',
  title: 'Peace of Mind',
  description: 'We provide clarity, reassurance, and professional support throughout your healthcare journey.',
  icon: 'Handshake',
  details: "Tapping into our extensive medical background, we offer emotional support and practical guidance, helping you feel confident and cared for every step of the way."
}];


export const testimonials = [
{
  id: '1',
  name: 'Sarah M.',
  location: 'Cary, NC',
  text: 'Having a nurse with my mother at her appointments has been life-changing. She actually understands what the doctor says now, and I have peace of mind knowing she has professional support.',
  rating: 5
},
{
  id: '2',
  name: 'John D.',
  location: 'Raleigh, NC',
  text: 'The care and attention my father receives is exceptional. The nurse asks questions we never thought to ask and ensures he follows his treatment plan correctly.',
  rating: 5
},
{
  id: '3',
  name: 'Patricia L.',
  location: 'Apex, NC',
  text: 'I cannot recommend this service enough. It\'s not just about medical knowledge—it\'s about having someone who truly cares and advocates for you.',
  rating: 5
}];


export const aboutInfo = {
  title: 'Meet Nurse Gerri — Your Advocate in the Healthcare System',
  description: `For more than 25 years, Gerri has stood at the intersection of medicine, compassion, and real-world advocacy — helping families ask better questions, understand complex care, and make confident decisions when it matters most.

A Registered Nurse with decades of hands-on clinical experience — currently serving patients at Duke Raleigh Hospital — Gerri has seen firsthand how overwhelming healthcare can feel for seniors and their families. Medical appointments move fast. Information gets lost. And too often, the people who need support the most leave with more confusion than clarity.

That's where she comes in.

Before returning to bedside nursing, Gerri spent 10 years as a State of Florida Long-Term Care Ombudsman, advocating for seniors and protecting their rights inside healthcare facilities. She knows how systems work — and more importantly, how to make them work for you.

Her approach blends professional expertise with genuine heart. Whether attending appointments as a second set of ears, helping families understand treatment options, or simply making sure the right questions get asked, Gerri brings calm, confidence, and clarity into moments that can otherwise feel overwhelming.

When she's not advocating for patients, you'll find her quilting, reading with her book club, enjoying movies with friends, or spending time with her pets, kids, and grandkids — the same family-first values she brings into every client relationship.

If you're looking for someone who will listen, guide, and stand beside you in the healthcare journey, you've found her.`,
  closingNote: 'Please fill out the form below if you wish to learn or discuss how I can help you or a family member.',
  qualifications: [
  'Licensed Registered Nurse with 25+ years experience',
  'Currently working at Duke Raleigh Hospital',
  'Former Ombudsman for 10 years (State of Florida)',
  'Specialized in senior care advocacy',
  'Long Term Care facility experience',
  'Personalized, one-on-one attention'],

  serviceAreas: [
  'Fuquay Varina',
  'Holly Springs',
  'Apex',
  'Cary'],

  serviceAreaNote: 'If need to attend appointments outside this service area, there will be an added cost.'
};

export const contactInfo = {
  phone: "$50 Client Intake & First Conslutation Fee",
  email: 'rn5398@gmail.com',
  serviceAreas: 'Fuquay Varina, Holly Springs, Apex, Cary, NC',
  serviceAreaNote: 'If need to attend appointments outside this service area, there will be an added cost.'
};

export const fees = {
  consultation: {
    price: 50.00,
    details: [
    'Meet at a location of your choosing',
    'Retrieve and go over your medical history',
    'Discuss medical concerns and questions you want me to explore',
    'Approve contacts (if any) you want included in the information sharing process']

  },
  officeVisit: {
    price: 30.00,
    unit: 'per hour',
    note: '*most office visits do not last more than a hour',
    arrangement: [
    'You will need to provide own transportation to the doctor\'s office and our nurse will meet you there.',
    'Exceptions can be made if you need our nurse to travel with you via provided transportation to and from your medical appointments.',
    'Our nurse will be with you during your entire doctor\'s visit unless you ask her to step outside.',
    'After the visit our nurse will remain with you until you are safely in transportation back home.']

  },
  importantNote: 'Insurance generally doesn\'t reimburse these services; coverage varies, so please verify with your insurer.'
};